import React from 'react'
import {
    FormControl, InputLabel, Select, MenuItem, Grid, TextField, Box, Button,
    Typography, Container, OutlinedInput, InputAdornment, Tooltip, Link, Accordion, AccordionSummary, AccordionDetails, IconButton, Input,
    FormLabel, Paper, Tab, Dialog, DialogActions, DialogContent, DialogTitle, Pagination, DialogContentText
} from '@mui/material';
import { Chip } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CancelIcon from '@mui/icons-material/Cancel';
import axiosInstance from '../lib/axios';
import Flag from '../Components/Ragistration/Booking/Flag';
import moment from 'moment';
import BokingCModal from '../Components/Ragistration/BConfirmation/BokingCModal';
import AccountGModal from '../Components/Ragistration/BConfirmation/AccountGModal';
import { useReactToPrint } from 'react-to-print';
import BReport from '../atoms/ReportFolder/BReport';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstanceForPG from '../lib/axiosFormPG';
import RefreshIcon from '@mui/icons-material/Refresh';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import axios from "../lib/axios";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AccountsTab from './ResidentDashboard/AccountsTab';
import ConfirmationDialog from './ReusableDailog';
import RoomSelection from './RoomSelection/RoomSelection';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../redux/propertySlice';
import { usePermissions } from '../GlobalFunction/userPermissions';
import { selectGatewayType } from '../redux/propertySlice';

const columns = [
    { id: 'BookId', label: 'BookId', minWidth: 50 },
    { id: 'RoomBedName', label: 'Unit No', minWidth: 100 },
    { id: 'BookNo', label: 'Booking No', minWidth: 120 },
    { id: 'BookDt', label: 'Book Date', minWidth: 130 },
    { id: 'BookSt', label: 'Status', minWidth: 130 },
    { id: 'ResidentName', label: 'Resident', minWidth: 130 },
    { id: 'MobileNo', label: 'Mobile', minWidth: 150 },
    { id: 'Duration', label: 'Duration', minWidth: 100 },
    { id: 'CheckinDt', label: 'Check-In', minWidth: 100 },
    { id: 'CheckoutDt', label: 'Check-Out', minWidth: 100 }
];

function CheckIn() {
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const { register, watch, setValue, reset } = useForm();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [AccountGenerateRow, setAccountGenerateRow] = useState([]);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [OpenLoader, setOpenLoader] = useState(false);
    const [TransactionData, setTransactionData] = useState([]);
    const [OpenHistoryTableDialog, setOpenHistoryTableDialog] = useState(false);
    const [OpenHistoryTable, setOpenHistoryTable] = useState(false);
    const [AccGenerate, setAccGenerate] = useState(false);
    const [BookId, setBookId] = useState(-1);
    const [activeView, setActiveView] = useState('advice');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);
    const [searchTerms, setSearchTerms] = useState({});
    const [OpenAccountGDialog, setOpenAccountGDialog] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const contentRef = useRef(null);
    const [catId, setCatId] = useState('')
    const [docTypeName, setDocTypeName] = useState([])
    const [minCheckInDate, setMinCheckInDate] = useState(null);
    const location = useLocation();
    const [isDepositPaid, setIsDepositPaid] = useState(false);
    const [propId, setPropId] = useState(null);
    const [payAdvice, setPayAdvice] = useState([]);
    const [showPayAdvice, setShowPayAdvice] = useState(false);
    const [regenerate, setRegenerate] = useState(false);
    const [selectedDate, setSelectedDate] = useState(
        new Date().toLocaleDateString('en-GB')
    );
    const [selected, setSelected] = useState('')
    const [DateFrom, setDateFrom] = React.useState(dayjs(new Date));
    const [DateTo, setDateTo] = React.useState(dayjs());
    const [isRoomLoading, setIsRoomLoading] = useState(false);
    const [docValue, setDocValue] = useState("");
    const [residentid, setResidentId] = useState(null)
    const [previewImage, setPreviewImage] = useState(null);
    const [Mode, setMode] = useState('add');
    const [documents, setDocuments] = useState([]);
    const [selectedDocType, setSelectedDocType] = useState({ Id: '', Name: '' });
    const [openKYC, setOpenKYC] = useState(false);
    const [mstResidentDocId, setMstResidentDocId] = useState(null);
    const [dbFlag, setDbFlag] = useState("");
    const handlePrint = useReactToPrint({ contentRef });
    const [imageError, setImageError] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openCheckinConfirm, setOpenCheckinConfirm] = useState(false);
    const [openConfirmGen, setOpenConfirmGen] = useState(false);
    const [accountData, setAccountData] = useState([])
    const [hasUnpaidRent, setHasUnpaidRent] = useState(false);
    const [docExpiryDate, setDocExpiryDate] = useState(null);
    const [oldBedId, setOldBedId] = useState('')
    const [PlanDrp, setPlanDrp] = useState([]);
    const [emailResponse, setEmailResponse] = useState(null);
    const baseUrl = window.location.origin;
    const globalProperty = useSelector(selectGlobalProperty);
    const [loadingPaymentLinks, setLoadingPaymentLinks] = useState({});
    const [isCheckedIn, setIsCheckedIn] = useState(false);
    const [openCancelConfirm, setOpenCancelConfirm] = useState(false);
    const permissions = usePermissions("Check-In");
    const gatewayType = useSelector(selectGatewayType);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-IN');
    };

    const fetchPlanDrpData = async () => {
        const Flag = Mode === "add" ? "" : "R";
        try {
            const response = await axiosInstance.post(`MstRoomPlan/getMstRoomPlandrp`,
                { Flag, PropId: propId },
            );

            if (response.data.Status === 0) {
                setPlanDrp(response.data.Data);
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    }

    useEffect(() => {
        if (propId) {
            fetchPlanDrpData();
        }
    }, [propId]);

    useEffect(() => {
        // let MobileNo = location.state?.MobileNo?.MobileNo;
        let BookId = location?.state?.BookId
        if (BookId) {
            // handleMobileChange(MobileNo, "B");
            fetchTransactionData(BookId)
        } else {
            setMode("add");
        }
        const fetchApi = async () => {
            setValue("CountryIcon", Flag);
            setValue("BookDt", "");
            setValue("BookDtFrom", "");
            setValue("BookUpToDt", "");
            setValue("CheckoutDt", "")
            // await fetchDataOfBooking();
        };
        fetchApi();
    }, [location.state?.BookId]);

    useEffect(() => {

        if (TransactionData.length > 0 && TransactionData[0].BookDtFrom) {
            const { MobileNo, ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, CheckoutDt, CheckinDt, TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, BookId, PropName, Email, PlanName, MonthlyAmt, BookSt } = TransactionData[0];
            let obj = { ResidentName, BookNo, BookDt, Duration, BookDtFrom, CheckoutDt, BookUpToDt, CheckinDt, TopupAmt, AdvcRcble, MobileNo, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, Email, PlanName, MonthlyAmt, BookSt }

            // setSelectedDate(currentDateObj >= bookFromDateObj ? currentDate : BookDtFrom);
            // setSelectedDate(defaultDate);
            if (BookSt === "C") {
                setSelectedDate(BookDtFrom);
            } else {
                const currentDate = new Date().toISOString()?.split("T")[0];
                const bookFromDateObj = new Date(BookDtFrom);
                const currentDateObj = new Date(currentDate);
                bookFromDateObj.setHours(0, 0, 0, 0);
                currentDateObj.setHours(0, 0, 0, 0);

                setSelectedDate(currentDateObj >= bookFromDateObj ? currentDate : BookDtFrom);
            }
            // setValue("CheckinDt", selectedDate);
            setMinCheckInDate(BookDtFrom);
            setValue("MonthlyAmt", Math.round(NetAmt / Duration));
            setObjValue(obj);
            setValue("Email", Email);
            setBookId(BookId)
            const fetchDataAndSet = async () => {
                await fetchRoomBedData(TransactionData[0].RoomBedId, TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, TransactionData[0].PropId);
                // await fetchPlanData(TransactionData[0].RoomPlanId);
                await fetchServicesData(TransactionData[0].TransPlanId, TransactionData[0].MessPlanId);
            }
            fetchDataAndSet();
            setNetAmount();
        }

    }, [TransactionData]);

    const GetDocTypeName = async () => {
        try {
            const response = await axios.post(`MstSource/getDocumentTypedrp`)
            if (response.data && response.data.Data) {
                setDocTypeName(response.data.Data)
            }
        } catch (err) {
            console.error('Error fetching DocTypeName:', err);
        }
    }

    useEffect(() => {
        GetDocTypeName()
    }, [])

    const handleFileUpload = (event) => {
        const file = event.target.files[0];

        if (file) {
            setSelectedFile(file);
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    useEffect(() => {
        if (AccountGenerateRow.length > 0) {
            setOpenAccountGDialog(true);
            handleLoaderClose();
        }

    }, [AccountGenerateRow])

    const handleSearchChange = (columnId, value) => {
        setSearchTerms(prev => ({ ...prev, [columnId]: value }));
        setPage(0);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const fetchPayAdvice = async (BookId) => {
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                "PytAdvDt": moment().format("YYYY-MM-DD"),
                "Flag": "GenPytAdv",
                "BookId": BookId
            });

            if (response.data.Status === 0) {
                setPayAdvice(response.data.Data);
                setShowPayAdvice(true);

                const firstInstallmentPaid = response.data.Data.some(
                    item => item.Remark?.includes("Installment 1")
                        && item.PaymentSt !== "Paid" && item.PaymentSt !== "Partial"
                );
                setHasUnpaidRent(firstInstallmentPaid);
            }
        } catch (error) {
            console.error('Error fetching payment advice:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredRows = React.useMemo(() => {
        return rows.filter(row => {
            return Object.entries(searchTerms).every(([columnId, term]) => {
                if (!term) return true;
                const value = row[columnId];
                if (typeof value === 'string') {
                    return value.toLowerCase().includes(term.toLowerCase());
                } else if (typeof value === 'number') {
                    return value.toString().includes(term);
                }
                return true;
            });
        });
    }, [searchTerms, rows]);

    const fetchDataOfBooking = async () => {
        try {
            const response = await axiosInstance.post(`TrnBooking/GetTrnBookingDashBoard`, {
                PageNumber: 1,
                PageSize: 1,
                SearchText: '',
                Flag: 'PendChk',
                MobileNo: '',
                BookNo: '',
                PropId: globalProperty,
            });

            if (response.data.Status === 0) {
                const formattedData = response.data.Data.map(checkin => ({
                    ...checkin,
                    BookSt: checkin.BookSt === "C" ? "Confirmed" : checkin.BookSt === "B" ? "Booked" : ""
                }));
                setRows(formattedData);
                const restId = response.data.Data[0].ResidentId;
                const propId = response.data.Data[0].PropId
                setOldBedId(response.data.Data[0].RoomBedId)
                setPropId(propId)
                setResidentId(restId)
                // await fetchDocuments(restId);
            } else {
                setRows([]);
            }
        } catch (error) {
            console.error('Error fetching Booking data:', error);
        }
    };

    const fetchTransactionData = async (bookId) => {
        if (!bookId) return;

        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/RetriveTrnBooking`,
                {
                    "BookId": bookId,
                    "Flag": "R",
                    "CreatedBy": UserId
                }
            );

            if (response.data.Status === 0) {
                setIsDataLoaded(true);
                const bookingData = response.data.Data[0];
                const {
                    BookSt, PropId, ResidentId, RoomBedId, MobileNo, ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, CheckoutDt,
                    TopupAmt,
                    AdvcRcble,
                    DiscAmt,
                    TotalRent,
                    NetAmt,
                    BedRent,
                    FreeMonth,
                    PropName,
                    CheckinDt,
                    Email,
                    PlanName,
                    MonthlyAmt,
                    CheckingDt,
                    BookStatus
                } = bookingData;
                setAccountData(bookingData);
                setOldBedId(RoomBedId);
                setResidentId(ResidentId);
                setPropId(PropId);
                setBookId(bookId);
                setValue("MobileNo", MobileNo);
                setValue("ResidentName", ResidentName);
                setValue("BookNo", BookNo);
                setValue("BookDt", BookDt);
                setValue("Duration", Duration);
                setValue("BookDtFrom", BookDtFrom);
                setValue("BookUpToDt", BookUpToDt);
                setValue("CheckoutDt", CheckoutDt);
                setValue("TopupAmt", TopupAmt);
                setValue("AdvcRcble", AdvcRcble);
                setValue("DiscAmt", DiscAmt);
                setValue("TotalRent", TotalRent);
                setValue("NetAmt", NetAmt);
                setValue("BedRent", BedRent);
                setValue("FreeMonth", FreeMonth);
                setValue("PropName", PropName);
                setValue("Email", Email);
                setValue("PlanName", PlanName);
                setValue("MonthlyAmt", MonthlyAmt);
                setValue("CheckinDt", CheckinDt);
                setValue('CheckingDt', CheckingDt)
                if (BookSt === "C") {
                    setSelectedDate(CheckinDt);
                } else {
                    const currentDate = new Date().toISOString()?.split("T")[0];
                    const bookFromDateObj = new Date(BookDtFrom);
                    const currentDateObj = new Date(currentDate);
                    bookFromDateObj.setHours(0, 0, 0, 0);
                    currentDateObj.setHours(0, 0, 0, 0);
                    setSelectedDate(currentDateObj >= bookFromDateObj ? currentDate : BookDtFrom);
                }

                setMinCheckInDate(BookDtFrom);

                if (ResidentId) {
                    await fetchDocuments(ResidentId);
                }

                setAccGenerate(BookSt === "B");
                setTransactionData(response.data.Data);
                await fetchPayAdvice(bookId);
                await fetchRoomBedData(RoomBedId, BookDtFrom, BookUpToDt, PropId);
                await fetchServicesData(bookingData.TransPlanId, bookingData.MessPlanId);

            } else {
                setIsDataLoaded(false);
                toast.info("Booking Not Found");
                resetFuncM();
            }
        } catch (error) {
            toast.error("Failed to load booking data");
        } finally {
            setOpenLoader(false);
        }
    };

    const handleMobileChange = async (e, Separator) => {
        let val = "";
        if (Separator === "A") {
            val = e.target.value.trim()
        } else {
            val = e.trim();
        }
        if (val.length >= 10) {
            try {
                const response = await axiosInstance.post(`TrnBooking/GetTrnBookingDashBoard`,
                    {
                        "start": 1,
                        "PageSize": 1,
                        "SearchText": '',
                        "Flag": '',
                        "MobileNo": val,
                        "BookNo": '',
                        "PropId": 1,
                    }
                );

                if (response.data.Status === 0) {
                    setIsDataLoaded(true);
                    const { BookSt, PropId } = response.data.Data[0];
                    const data = response.data.Data[0]
                    setAccountData(data)
                    const restId = response.data.Data[0].ResidentId;
                    setOldBedId(response.data.Data[0].RoomBedId)

                    setResidentId(restId)
                    setPropId(PropId);
                    if (restId) {
                        await fetchDocuments(restId);
                    }
                    // await fetchDocuments(restId);
                    if (BookSt === "B") {
                        setAccGenerate(true);

                    } else {
                        setAccGenerate(false);
                    }
                    setTransactionData(response.data.Data);
                    await fetchPayAdvice(response.data.Data[0].BookId);
                } else {
                    setIsDataLoaded(false)
                    toast.info("Booking Doesn't Exist On This Number");
                    resetFuncM();
                    setValue("BookNo", "");
                    setBookId(-1);

                }
            } catch (error) {
                console.error('Error fetching Booking data:', error);
            }
        } else if (val.length === 9) {
            resetFuncM();
            setValue("BookNo", "");
            setBookId(-1);
        }

        Separator === "B" && handleClose();
    };
    const [panNo, setPanNo] = useState("");
    const [aadharNo, setAadharNo] = useState("");

    useEffect(() => {
        if (documents?.MstResidentList?.[0]) {
            setPanNo(documents.MstResidentList[0].PanNo || "");
            setAadharNo(documents.MstResidentList[0].AadharNo || "");
        }
    }, [documents, globalProperty]);

    const fetchDocuments = async (residentid) => {
        try {
            const response = await axios.post(`ResidentMst/RetriveResidentMstAll`, {
                ResidentId: residentid,
                Flag: "R",
                Mobile: "",
            });

            if (response.data?.Data?.MstResidentList[0]?.mstResidentDocEntities) {
                setAccountData(response.data.Data[0])
                const documentsData = response.data.Data.MstResidentList[0].mstResidentDocEntities;
                setDocuments(documentsData);
                const fixedDocuments = documentsData.map(doc => ({
                    ...doc,
                    ImgPath: doc.ImgPath.startsWith("http:/") ? doc.ImgPath.replace("http:/", "http://") : doc.ImgPath
                }));
                setDocuments(fixedDocuments);
                if (documentsData.length > 0) {
                    const firstDoc = documentsData[0];
                    setSelectedDocType({ Id: firstDoc.DocTypeId, Name: firstDoc.DocTypeName });
                    setDocValue(firstDoc.DocNo);
                    setSelectedDate(firstDoc.DocExpDt ? dayjs(firstDoc.DocExpDt) : null);
                    setMstResidentDocId(firstDoc.MstResidentDocId);
                    setDbFlag(firstDoc.DBFLAG);
                }
            } else {
                setDocuments([]);
            }
        } catch (error) {
            console.error("Error fetching Resident documents:", error);
        }
    };

    useEffect(() => {
        GetDocTypeName();
        if (residentid) {
            fetchDocuments(residentid);
        }
    }, [residentid]);

    const handleDocTypeChange = (e) => {
        const selectedId = e.target.value;
        const selectedItem = docTypeName.find((item) => item.Id === selectedId);

        setSelectedDocType({ Id: selectedItem?.Id || "", Name: selectedItem?.Name || "" });

        const existingDoc = documents.find((doc) => doc.DocTypeId === selectedId);

        if (existingDoc) {
            setDocValue(existingDoc.DocNo);
            setSelectedDate(existingDoc.DocExpDt ? dayjs(existingDoc.DocExpDt) : null);
        } else {
            setDocValue("");
            setSelectedDate(null);
        }
    };

    const handleBookNoChange = async (e, Separator) => {
        let val = "";
        if (Separator === "A") {
            val = e.target.value.trim()
        } else {
            val = e.trim();
        }

        if (val.length >= 8) {
            try {
                const response = await axiosInstance.post(
                    `TrnBooking/GetTrnBookingDashBoard`,
                    {
                        "start": 1,
                        "PageSize": 1,
                        "SearchText": '',
                        "Flag": '',
                        "MobileNo": '',
                        "BookNo": val,
                        "PropId": 1,
                    }
                );
                if (response.data.Status === 0) {
                    setIsDataLoaded(true);
                    // setAccountData(response.data.Data[0])
                    const { BookSt, PropId, PlanName } = response.data.Data[0];
                    const restId = response.data.Data[0].ResidentId;
                    setCatId(response.data.Data[0].BedCatId)
                    setResidentId(restId)
                    setPropId(PropId);
                    // await fetchDocuments(restId);
                    if (restId) {
                        await fetchDocuments(restId);
                    }
                    if (BookSt === "B") {
                        setAccGenerate(true);

                    } else {
                        setAccGenerate(false);
                    }
                    setTransactionData(response.data.Data);
                    await fetchPayAdvice(response.data.Data[0].BookId);
                } else {
                    setIsDataLoaded(false);
                    toast.info("Booking Doesn't Exist On This Number");
                    resetFuncM();
                    setValue("MobileNo", "");
                    setBookId(-1);
                }
            } catch (error) {
                console.error('Error fetching Booking data:', error);
            }
        } else if (val.length === 7) {
            resetFuncM();
            setValue("MobileNo", "");
        }
        Separator === "B" && handleClose();
    }

    const fetchRoomBedData = async (RoomBedId, date1, date2, PropId) => {
        try {
            const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
                BookFromDt: date1,
                BookToDt: date2,
                PropId: PropId,
                Flag: "",
                RoomBedId: RoomBedId
            });
            if (response.data.Status === 0) {
                handleRowDoubleClick(response.data.Data[0]);
            }
        } catch (error) {
            console.error('Error fetching company data:', error);
        }
    };

    const handleRowDoubleClick = async (row) => {
        const {
            WingName,
            FloorName,
            RoomTypeName,
            RoomViewNAme,
            RoomBedTypeName,
            RoombedName,
            BedRent,
            RoomBedId
        } = row;

        const obj = {
            WingName,
            FloorName,
            RoomTypeName,
            RoomViewNAme,
            RoomBedTypeName,
            RoombedName,
            BedRent
        };
        setSelected(row)
        setObjValue(obj);
        setOpenHistoryTable(false);
        if (BookId !== -1) {
            try {
                setOpenLoader(true);
                const response = await axiosInstance.post('BedCalendar/GetPropWiseBedCalendarMonthRoomBed', {
                    RoomBedId: RoomBedId,
                    PropId: propId,
                    BookDtFrom: DateFrom.format('YYYY-MM-DD'),
                    CheckoutDt: DateTo.format('YYYY-MM-DD'),
                    Flag: "",
                    OldRoomBedId: oldBedId
                });

                if (response.data.Status === 0) {
                    toast.success("Room changed successfully");
                    await handleMobileChange(watch('MobileNo'), "B");
                } else {
                    // toast.error(response.data.Message || "Failed to change room");
                }
            } catch (error) {
                console.error('Error changing room:', error);
                // toast.error("Error changing room");
            } finally {
                setOpenLoader(false);
            }
        }
    };

    const setObjValue = (obj) => {
        for (let key in obj) {
            setValue(key, obj[key]);
        }
    };

    const handleClose = () => {
        setOpenHistoryTableDialog(false);
        setPage(0);
        setTimeout(() => {
            setSearchTerms({});
        }, [500]);
    };

    const setNetAmount = () => {
        setValue("TotalAmt", ((watch("TAmount") || 0) + (watch("MAmount") || 0) + (watch("TopupAmt") || 0) + (watch("AdvcRcble") || 0)));
    };

    const fetchServicesData = async (TransPlanId, MessPlanId) => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(`MstTransPlan/getMstTransPlandrp`,
                { Flag, UserId },
            );
            console.log("property-data", response);
            if (response.data.Status === 0) {
                // setTransPlanDrp(response.data.Data);
                let obj = response.data.Data.find(obj => obj.TransPlanID === TransPlanId);
                if (obj) {
                    console.log("Trans Amounr", obj.Amount)
                    setValue("TAmount", obj.Amount);
                } else {
                    setValue("TAmount", 0);
                }
                setNetAmount()
            } else {
                toast.error('Error fetching Trans data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }

        try {
            const response = await axiosInstance.post(
                `MstMessPlan/getMstMessPlandrp`,
                { Flag, UserId },
            );

            if (response.data.Status === 0) {
                // setTransPlanDrp(response.data.Data);
                let obj = response.data.Data.find(obj => obj.MessPlanID === MessPlanId);
                if (obj) {
                    setValue("MAmount", obj.Amount);
                } else {
                    setValue("MAmount", 0);
                }
                setNetAmount();

            } else {
            }
        } catch (error) {
            toast.error('Error fetching Plan data');
        }
    }

    const resetFuncM = () => {
        const obj = {
            "ResidentName": "",
            "BookDt": "",
            "Duration": "",
            "BookDtFrom": "",
            "BookUpToDt": "",
            "WingName": "",
            "FloorName": "",
            "RoomTypeName": "",
            "RoombedName": "",
            "RoomBedTypeName": "",
            "BedRent": "",
            "PlanName": "",
            "PlanTenur": "",
            "FreeMonth": "0",
            "LastAdjMonths": "0",
            "IncRentPerc": "",
            "DepositAmt": "",
            "TopupAmt": "",
            "Tamt": "",
            "MAmount": "",
            "TAmount": "",
            "TotalRent": "",
            "DiscAmt": "",
            "NetAmt": "",
            "MonthlyAmt": "",
            "PropName": "",
            "DocNo": "",
            "CheckoutDt": ""

        }
        for (let key in obj) {
            setValue(key, "")
        }
        setValue("CountryIcon", Flag);
        setTransactionData([]);
        setDocuments([])
        setResidentId(null);
        setSelectedDocType({ Id: '', Name: '' });
        setDocValue("");
        setSelectedDate(null);
        setMstResidentDocId(null);
        setDbFlag("");
        setPanNo("");
        setAadharNo("");
    };

    const handleClickCancel = () => {
        navigate("/enquiry/checkintable");
    }
    const handleLoaderClose = () => {
        setOpenLoader(false);
    }
    const handleToggle = () => {
        setOpenKYC(!openKYC);
    };

    const handleUpdateDoc = async () => {
        try {
            if (!selectedDocType.Id || !docValue) {
                toast.error("Please fill all required fields");
                return;
            }

            const getBase64 = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                });
            };

            let base64Image = "";
            if (selectedFile) {
                base64Image = await getBase64(selectedFile);
            }

            // const formattedDate = selectedDate ? dayjs(selectedDate).format("YYYY-MM-DD") : null;
            const selectedDocument = documents.find((doc) => doc.DocTypeId === selectedDocType.Id);
            const formattedDate = docExpiryDate ? dayjs(docExpiryDate).format("YYYY-MM-DD") : null;

            const payload = {
                DBFLAG: selectedDocument ? "U" : "I",
                MstResidentDocId: selectedDocument ? selectedDocument.MstResidentDocId : 0,
                ResidentId: residentid,
                DocTypeId: selectedDocType.Id,
                Remark: selectedDocument ? "Document updated" : "New document inserted",
                DocTypeName: selectedDocType.Name,
                ImgName: selectedFile ? selectedFile.name : "",
                DocNo: docValue,
                DocExpDt: formattedDate ? formattedDate : '',
                ImgPath: base64Image,
            };
            const token = `eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU`;

            const response = await axios.post(`${process.env.REACT_APP_API_URL}ResidentMst/MstResidentDocSave`, payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data) {
                toast.success(selectedDocument ? "Document updated successfully" : "Document inserted successfully");
                await fetchDocuments(residentid);
            }
        } catch (error) {
            console.error("Error updating/inserting document:", error);
            toast.error("Failed to update/insert document. Please try again.");
        }
    };

    const handleClick = () => {
        navigate('/masters/residenttable')
    }

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleCheckInClick = () => {
        if (BookId === -1) {
            toast.info("Nothing Any Transaction Is Visible");
            return;
        }
        if (!watch('RoombedName')) {
            toast.error("Room allocation pending. Kindly proceed to the pre-checkin counter before check-in");
            return;
        }
        if (hasUnpaidRent) {
            toast.error("Please make all rent payments first before checking in");
            return;
        }
        setOpenCheckinConfirm(true);
    };

    const handleCheckinConfirm = async () => {
        const bookFromDate = watch('BookDtFrom');
        const selectedDateObj = new Date(dayjs(selectedDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD'));
        const bookFromDateObj = new Date(bookFromDate);

        if (selectedDateObj < bookFromDateObj) {
            toast.error(`Check-in date cannot be before ${new Date(bookFromDate).toLocaleDateString('en-GB')}`);
            return;
        }
        setOpenLoader(true);
        setOpenCheckinConfirm(false);
        const formattedCheckinDate = selectedDate
            ? dayjs(selectedDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD')
            : dayjs().format('YYYY-MM-DD');
        try {
            const response = await axiosInstance.post(`TrnBooking/TrnBookingConfirmation`,
                {
                    "BookId": BookId,
                    "CreatedBy": UserId,
                    "Flag": "O",
                    "CreatedDate": formattedCheckinDate
                },
            );
            if (response.data.Status === 0) {
                toast.success("CheckIn Successfully");
                setIsCheckedIn(true);
                fetchDataOfBooking()
            } else {
                toast.error(response.data.Message || "Operation failed");
            }
        } catch (error) {
            toast.error('Error fetching CheckIn data');
        } finally {
            setOpenLoader(false);
        }
    };

    const handleChnagePlan = () => {
        const bookingNo = watch('BookNo');
        if (!bookingNo) {
            toast.error("No booking number available");
            return;
        }
        navigate('/planchange', { state: { BookId: BookId, mode: 'view' } });
    };

    const selectedDocument = documents.find((doc) => doc.DocTypeId === selectedDocType.Id);
    const formatDateToDDMMYYYY = (dateString) => {
        if (!dateString) return '';

        if (dateString.includes('/')) {
            return dateString;
        }
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const handleClickCheckAva = async () => {
        await fetchDataOfBooking();
        setOpenHistoryTableDialog(true);
    };

    const handleClickCheckAvaCal = () => {
        const startDate = dayjs(watch('BookDtFrom'));
        const endDate = dayjs(watch('BookUpToDt'));
        setDateFrom(startDate);
        setDateTo(endDate);
        setOpenHistoryTable(true);
    };

    const handleCloseRoom = () => {
        setOpenHistoryTable(false)
    };

    const handleAccountGenerateClick = async () => {
        if (BookId === -1) {
            toast.info("Transaction is Not Visible!!");
            return;
        }

        setOpenLoader(true);
        try {
            const response = await axiosInstance.post(`TrnBooking/AccountGenerateTrnBooking`,
                {
                    "BookId": BookId,
                    "CreatedBy": UserId,
                    "AccountGenerate": "1",
                    "IsAccGen": "",
                    "IsDepPaid": isDepositPaid ? "Y" : "N"
                }
            );

            if (response.data.Status === 0) {
                try {
                    const dataResponse = await axiosInstance.post(`BedCalendar/GetTrnBookingDtlwise`, {
                        "Flag": "",
                        "BookId": BookId
                    });

                    if (dataResponse.data.Status === 0) {
                        const formattedData = dataResponse.data.Data.map(obj => {
                            return { ...obj, PyadDt: moment(obj.PyadDt).format("MM-DD-YYYY") }
                        });
                        sessionStorage.setItem('accountGenerateData', JSON.stringify(formattedData));
                        navigate(`/accgeneratetable`, {
                            state: {
                                accountData: formattedData,
                                bookingInfo: {
                                    residentName: watch("ResidentName"),
                                    bookNo: watch("BookNo"),
                                    mobileNo: watch("MobileNo")
                                }
                            }
                        });
                    } else {
                        toast.error(dataResponse.data.Message || 'Error fetching account data');
                    }
                } catch (error) {
                    toast.error('Error fetching account data');
                }
            } else {
                toast.error(response.data.Message || 'Error in account generation');
            }
        } catch (error) {
            toast.error('Error in account generation');
        } finally {
            setOpenLoader(false);
        }
    };

    const handleSendPaymentLink = async (item) => {
        try {
            setIsLoading(true);
            setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: true }));
            const userId = parseInt(sessionStorage.getItem('UserId'));
            const baseUrl = window.location.origin;


            let paymentResponse = null;

            if (gatewayType === 'CashFree') {
                const paymentDetails = {
                    customer_details: {
                        customer_email: item.Email || "",
                        customer_name: item.ResidentName,
                        customer_phone: item.MobileNo
                    },
                    link_amount: item.Amount || 0,
                    link_auto_reminders: true,
                    link_currency: "INR",
                    link_expiry_time: "2026-06-09T15:04:05+05:30",
                    link_id: "Testing9062026",
                    PropId: propId,
                    link_meta: {
                        notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                        return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                        upi_intent: false
                    },
                    PropId: item.PropId,
                    link_minimum_partial_amount: item.Amount || 0,
                    link_notes: {
                        key_1: "CashFreepay",
                        key_2: "linkCashfree"
                    },
                    link_notify: {
                        send_email: false,
                        send_sms: true
                    },
                    link_partial_payments: false,
                    link_purpose: item.Remark,
                    ResidentId: item.ResidentId,
                    Flag: "Active",
                    Remark: "Testing",
                    TrjType: "TrnPytAdv",
                    TrjDocNo: item.PytAdvNo,
                    TrjDocId: item.PytAdvId,
                    cf_payment_id: "",
                    payment_status: "",
                    PropId: item.PropId,
                };

                const response = await axiosInstanceForPG.post(
                    `PaymentGatewayLog/CreateCashFreeLink`,
                    paymentDetails,
                );
                if (response.data.Status == 1) {
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return toast.error(response.data.Message);
                }

                if (response.data.Status == 0) {
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return toast.success(response.data.Message);
                }

                paymentResponse = response.data;
                if (typeof paymentResponse === 'string') {
                    paymentResponse = JSON.parse(paymentResponse);
                }

                if (!paymentResponse || !paymentResponse.link_url) {
                    console.error("Invalid payment response:", paymentResponse);
                    toast.error("Failed to create payment link");
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return;
                }

            } else if (gatewayType === 'Instamojo') {
                const paymentDetails = {
                    purpose: item.Remark || `Payment Advice ${item.PytAdvNo}`,
                    amount: item.Amount || 0,
                    buyer_name: item.ResidentName || '',
                    email: item.Email || '',
                    phone: item.MobileNo || '',
                    redirect_url: `${baseUrl}/payment-success`,
                    redirecturl: `${baseUrl}/payment-success/`,
                    webhook_url: '',
                    ResidentId: item.ResidentId,
                    TrjDocId: item.PytAdvId || 0,
                    TrjType: "TrnPytAdv",
                    TrjDocNo: item.PytAdvNo || '',
                    PropId: item.PropId || 0,
                };

                const response = await axiosInstanceForPG.post(
                    `Payment/CreatePaymentOrder`,
                    paymentDetails,
                );
                if (response.data.Status === 1) {
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return toast.error(response.data.Message);
                }

                if (response.data.Status === 0) {
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return toast.success(response.data.Message);
                }

                paymentResponse = JSON.parse(response.data);

                if (!paymentResponse || !paymentResponse.payment_request || !paymentResponse.payment_request.longurl) {
                    console.error("Invalid payment response:", paymentResponse);
                    toast.error("Failed to create payment link");
                    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                    setIsLoading(false);
                    return;
                }

            } else {
                toast.error(`Unsupported gateway type: ${gatewayType}`);
                setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                setIsLoading(false);
                return;
            }

            const paymentToken = gatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
            const paymentUrl = gatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl;
            const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;

            let paymentLogPayload;
            if (gatewayType === 'CashFree') {
                paymentLogPayload = {
                    id: paymentResponse.link_id,
                    cf_link_id: paymentResponse.cf_link_id,
                    phone: paymentResponse.customer_details.customer_phone,
                    email: paymentResponse.customer_details.customer_email,
                    buyer_name: paymentResponse.customer_details.customer_name || 'null',
                    amount: paymentResponse.link_amount,
                    purpose: paymentResponse.link_purpose,
                    expires_at: null,
                    status: paymentResponse.link_status,
                    send_sms: paymentResponse.link_notify.send_sms,
                    send_email: paymentResponse.link_notify.send_email,
                    sms_status: 'null',
                    email_status: 'null',
                    shorturl: 'null',
                    longurl: paymentResponse.link_url,
                    redirect_url: paymentResponse.link_meta.return_url,
                    webhook: 'null',
                    allow_repeated_payments: true,
                    created_at: paymentResponse.link_created_at,
                    modified_at: paymentResponse.link_created_at,
                    ResidentId: item.ResidentId,
                    link_qrcode: paymentResponse.link_qrcode,
                    TrjDocNo: item.PytAdvNo,
                    TrjDocId: item.PytAdvId,
                    TrjType: "TrnPytAdv",
                    Flag: "Active",
                    Remark: "Payment Link for Payment Advice",
                    Gatewaytype: "CashFree",
                };
            } else {
                paymentLogPayload = {
                    id: paymentResponse.payment_request.id,
                    phone: paymentResponse.payment_request.phone,
                    email: paymentResponse.payment_request.email,
                    buyer_name: paymentResponse.payment_request.buyer_name,
                    amount: paymentResponse.payment_request.amount,
                    purpose: paymentResponse.payment_request.purpose,
                    expires_at: paymentResponse.payment_request.expires_at,
                    status: paymentResponse.payment_request.status,
                    send_sms: paymentResponse.payment_request.send_sms,
                    send_email: paymentResponse.payment_request.send_email,
                    sms_status: paymentResponse.payment_request.sms_status,
                    email_status: paymentResponse.payment_request.email_status,
                    shorturl: paymentResponse.payment_request.shorturl,
                    longurl: paymentResponse.payment_request.longurl,
                    redirect_url: paymentResponse.payment_request.redirect_url,
                    webhook: paymentResponse.payment_request.webhook,
                    allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
                    created_at: paymentResponse.payment_request.created_at,
                    modified_at: paymentResponse.payment_request.modified_at,
                    ResidentId: item.ResidentId,
                    TrjDocNo: item.PytAdvNo,
                    TrjDocId: item.PytAdvId,
                    TrjType: "TrnPytAdv",
                    Flag: "Active",
                    Remark: "Payment Link for Payment Advice",
                    Gatewaytype: "Instamojo",
                };
            }

            await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog',
                paymentLogPayload
            );

            const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${item.PytAdvNo}]`;
            const Body = `Hey <strong>${item.ResidentName}</strong>,<br><br>
        We would like to inform you that payment advice has been created for you tenancy at <strong>${item.PropName}</strong>.Please find attached your payment advice with this email <br><br>
        Following are the details : <br><br>
        Advice No: <strong>${item.PytAdvNo}</strong><br>
        Amount: <strong>${item.Amount}</strong><br>
        Date Of Issue: <strong>${formatDate(item.PytAdvDt)}</strong><br>
        Due Date: <strong>${formatDate(item.DueDt)}</strong><br>
        <strong>Payment Link:</strong> <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
        We hope you are having a pleasant stay with us. Do let us know if you need any assitance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
        Cheers,<br>
        Team Clanbridge`;

            const emailRequest = {
                ToEmail: item.Email ? [item.Email] : [],
                Subject,
                Body,
                Attachments: '',
                attachmentFilePaths: [],
                PropId: item.PropId,
                UserId: userId,
                TblName: 'TrnPytAdv',
                Id: item.PytAdvId,
            };

            const emailResponse = await axiosInstanceForPG.post(
                `EmailRequest/SendEmail`,
                emailRequest,
            );

            if (emailResponse.data.Status === 0) {
                toast.success(`Payment Link Sent Successfully for ${item.PytAdvNo}`);
            } else {
                toast.info(emailResponse.data.Message);
            }
            fetchPayAdvice(activeView === 'advice' ? 'GenPytAdv' : 'BookingWise');
        } catch (error) {
            toast.error("Failed to send payment link");
        } finally {
            setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
            setIsLoading(false);
        }
    };

    const handleChangeRoom = () => {
        if (!BookId) {
            toast.error("No booking selected");
            return;
        }
        navigate('/roomchange', { state: { BookId: BookId } });
    };

    const handleCancelConfirm = async () => {
        if (BookId === -1) {
            toast.info("No booking selected to cancel");
            return;
        }

        setOpenLoader(true);
        try {
            const response = await axiosInstance.post(`TrnBooking/TrnBookingConfirmation`,
                {
                    "BookId": BookId,
                    "CreatedBy": UserId,
                    "Flag": "C",
                    "CreatedDate": dayjs().format('YYYY-MM-DD')
                },
            );

            if (response.data.Status === 0) {
                toast.success("Check-In Cancelled Successfully");
                resetFuncM();
                setIsCheckedIn(false);
                // Refresh data if needed
                fetchDataOfBooking();
            } else {
                toast.error(response.data.Message || "Cancellation failed");
            }
        } catch (error) {
            toast.error('Error cancelling booking');
        } finally {
            setOpenLoader(false);
            setOpenCancelConfirm(false);
        }
    };

    return (
        <Box className="form-container">
            <ToastContainer />
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }}
                open={isRoomLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <BokingCModal OpenHistoryTableDialog={OpenHistoryTableDialog}
                handleClose={handleClose} columns={columns} TextField={TextField}
                handleSearchChange={handleSearchChange} filteredRows={filteredRows}
                page={page} rowsPerPage={rowsPerPage} handleMobileChange={handleMobileChange}
                handleChangePage={handleChangePage} handleBookNoChange={handleBookNoChange}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
            />

            <Grid container spacing={2} className="rasidant_grid" sx={{ p: { xs: 0, sm: 2 } }}>
                <Grid item>
                    <Container maxWidth="lg" spacing={1} justifyContent="center" alignItems="center" sx={{ p: { xs: 1, sm: 0 } }}>
                        <Grid item xs={12}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                justifyContent: 'space-between',
                                alignItems: { xs: 'flex-start', sm: 'center' },
                                gap: 2,
                                mb: 1
                            }}>
                                <Typography variant="h5" gutterBottom>
                                    Check-In
                                </Typography>

                                {TransactionData.length > 0 && TransactionData[0]?.BookStatus === "Checked In" && hasUnpaidRent == false ? (
                                    <Tooltip title={permissions.DeleteRec !== "1" ? "You don't have Permission" : "Cancel this check-in process"}>
                                        <span>
                                            <Button
                                                sx={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    background: '#dc3545',
                                                    color: 'white',
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                    padding: '3px 10px',
                                                    whiteSpace: 'nowrap',
                                                    height: '33px',
                                                    minWidth: 'auto',
                                                    boxShadow: '0 3px 5px 2px rgba(255, 82, 82, .3)',
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 5px 8px 2px rgba(255, 82, 82, .4)',
                                                        background: '#c52838ff',
                                                        cursor: 'pointer'
                                                    },
                                                }}
                                                onClick={() => setOpenCancelConfirm(true)}
                                                disabled={BookId === -1 || permissions.DeleteRec !== "1"}
                                            >
                                                <CancelIcon sx={{ fontSize: '18px', mr: 1 }} />
                                                <Typography variant="body2" sx={{
                                                    color: '#fff',
                                                    fontSize: '14px',
                                                    fontWeight: '500'
                                                }}>
                                                    Cancel Check-in
                                                </Typography>
                                            </Button>
                                        </span>
                                    </Tooltip>
                                ) : null}

                                <Box sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 1,
                                    justifyContent: { xs: 'flex-start', sm: 'flex-end' }
                                }}>
                                    <Button variant="contained" size="medium"
                                        sx={{
                                            height: { xs: 28, sm: 30 },
                                            fontSize: { xs: '12px', sm: '14px' },
                                            padding: { xs: '2px 6px', sm: '1px 8px' },
                                            minWidth: { xs: 'auto', sm: '100px' },
                                            backgroundColor: "#635bff",
                                            whiteSpace: 'nowrap',
                                            '&:hover': { backgroundColor: '#3f51b5' }
                                        }}
                                        onClick={handleClickCheckAva}
                                    >
                                        Get Data
                                    </Button>

                                    {TransactionData.length > 0 && TransactionData[0].BookStatus === "Checked In" && (
                                        <Button variant="contained" size="medium"
                                            sx={{
                                                height: { xs: 28, sm: 30 },
                                                fontSize: { xs: '12px', sm: '14px' },
                                                padding: { xs: '2px 6px', sm: '1px 8px' },
                                                minWidth: { xs: 'auto', sm: '100px' },
                                                backgroundColor: "#635bff",
                                                whiteSpace: 'nowrap',
                                                '&:hover': { backgroundColor: '#3f51b5' }
                                            }}
                                            onClick={handleChangeRoom}
                                        >
                                            Room change
                                        </Button>
                                    )}

                                    <Box onClick={handleClick}
                                        sx={{
                                            display: { xs: 'none', sm: 'inline-flex' },
                                            alignItems: 'center',
                                            backgroundColor: "#635bff",
                                            color: 'white',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            whiteSpace: 'nowrap',
                                            padding: { xs: '2px 6px', sm: '1px 8px' },
                                            height: { xs: '28px', sm: '32px' },
                                            minWidth: 'auto',
                                            '&:hover': {
                                                backgroundColor: '#3f51b5'
                                            }
                                        }}
                                    >
                                        <ArrowForwardIcon sx={{ fontSize: { xs: '14px', sm: '16px' }, marginRight: '4px' }} />
                                        <Typography variant="body2" sx={{ color: 'white' }}>
                                            Resident Master
                                        </Typography>
                                    </Box>
                                    {TransactionData.length > 0 && TransactionData[0].BookStatus === "Checked In" && (
                                        <Box
                                            sx={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                backgroundColor: "#635bff",
                                                color: 'white',
                                                borderRadius: '5px',
                                                cursor: 'pointer',
                                                padding: { xs: '2px 6px', sm: '1px 8px' },
                                                height: { xs: '28px', sm: '32px' },
                                                minWidth: 'auto',
                                                '&:hover': { backgroundColor: '#3f51b5' }
                                            }}
                                            onClick={isDataLoaded ? handleOpenDialog : null}
                                            disabled={!isDataLoaded}
                                        >
                                            <AccountBalanceIcon sx={{ fontSize: { xs: '14px', sm: '16px' }, marginRight: '6px' }} />
                                            <Typography sx={{ color: '#fff', fontSize: '14px' }}>
                                                Accounts
                                            </Typography>
                                        </Box>
                                    )}
                                    <Tooltip >
                                        <span>
                                            <Button variant="contained" size="small"
                                                sx={{
                                                    height: { xs: 28, sm: 30 },
                                                    fontSize: { xs: '12px', sm: '14px' },
                                                    padding: { xs: '2px 6px', sm: '1px 8px' },
                                                    // minWidth: { xs: 'auto', sm: '100px' },
                                                    backgroundColor: "#635bff",
                                                    whiteSpace: 'nowrap',
                                                    '&:hover': { backgroundColor: '#3f51b5' }
                                                }}
                                                onClick={handleClickCancel}
                                            >
                                                Exit
                                            </Button>
                                        </span>
                                    </Tooltip>

                                    <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="lg" fullWidth>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: '24px' }}>
                                            <DialogTitle>Account Details</DialogTitle>
                                            <DialogActions>
                                                <Button
                                                    onClick={handleCloseDialog}
                                                    variant="contained"
                                                    color="primary"
                                                    size='small'
                                                    sx={{ backgroundColor: '#6c67d6ff' }}
                                                >
                                                    <CloseIcon />
                                                </Button>
                                            </DialogActions>
                                        </div>
                                        <DialogContent>
                                            <AccountsTab bookingData={accountData} />
                                        </DialogContent>
                                    </Dialog>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid container md={12} spacing={0.5}>
                            <Grid item xs={12} md={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <div
                                                    style={{
                                                        width: 25,
                                                        height: 15,
                                                        backgroundImage: `url(${watch("CountryIcon")})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        borderRadius: '4px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                />
                                            </InputAdornment>
                                        }
                                        aria-describedby="outlined-weight-helper-text"
                                        placeholder={`Enter Booking  Mobile Number`}
                                        style={{ width: "100%", height: 40 }}
                                        value={watch('MobileNo') || ''}
                                        {...register('MobileNo', { onChange: (e) => handleMobileChange(e, 'A') })}
                                        inputProps={{
                                            'aria-label': 'weight',
                                            style: { height: 40 },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="BookNo"
                                    name="BookNo"
                                    label="Booking No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('BookNo') || ''}
                                    {...register('BookNo', { onChange: (e) => handleBookNoChange(e, 'A') })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="ResidentName"
                                    name="ResidentName"
                                    label="First Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('ResidentName') || ''}
                                    {...register('ResidentName')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={
                                            <>
                                                Actual Check-In Date <span style={{ color: "red" }}>*</span>
                                            </>
                                        }
                                        value={
                                            watch('CheckingDt')
                                                ? dayjs(watch('CheckingDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])
                                                : dayjs()
                                        }
                                        onChange={(newValue) => {
                                            if (newValue) {
                                                const formattedDate = newValue.format('DD/MM/YYYY');
                                                setSelectedDate(formattedDate);
                                                setValue("CheckingDt", formattedDate);
                                            } else {
                                                setSelectedDate('');
                                                setValue("CheckingDt", '');
                                            }
                                        }}
                                        minDate={minCheckInDate ? dayjs(minCheckInDate) : null}
                                        format="DD/MM/YYYY"
                                        className="custom-textfield"
                                        slotProps={{
                                            textField: {
                                                variant: 'filled',
                                                fullWidth: true,
                                                error: !selectedDate,
                                                helperText: !selectedDate ? 'Check-in date is required' : null,
                                            },
                                        }}
                                    // disabled={!isDataLoaded}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="PropName"
                                    name="PropName"
                                    label="Property Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('PropName') || ''}
                                    {...register('PropName')}
                                    InputProps={{
                                        readOnly: true,
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="BookDt"
                                    name="BookDt"
                                    label="Book Date"
                                    variant="filled"
                                    type="text"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formatDateToDDMMYYYY(watch('BookDt'))}
                                    {...register('BookDt')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="Duration"
                                    name="Duration"
                                    label="Duration"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('Duration') || ''}
                                    {...register('Duration')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="CheckinDt"
                                    name="CheckinDt"
                                    label="Check-In Date"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={moment(watch('CheckinDt')).isValid()
                                        ? moment(watch('CheckinDt')).format("DD/MM/YYYY")
                                        : ""}
                                    {...register('CheckinDt')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    placeholder="DD/MM/YYYY"
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="CheckoutDt"
                                    name="CheckoutDt"
                                    label="CheckOut Date"
                                    type="text"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={moment(watch('CheckoutDt')).isValid()
                                        ? moment(watch('CheckoutDt')).format("DD/MM/YYYY")
                                        : ""}
                                    {...register('CheckoutDt')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    placeholder="DD/MM/YYYY"
                                />
                            </Grid>
                        </Grid>
                        <hr></hr>
                        <Grid container spacing={1} sx={{ display: { xs: 'none', md: 'flex' } }}>
                            <Grid item xs={12} sm={1.5}>
                                <Typography variant="h6" gutterBottom>
                                    Room Details
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={10.5}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6} md={1.5}>
                                        <TextField
                                            id="WingName"
                                            name="WingName"
                                            label="Wing"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('WingName') || ''}
                                            {...register('WingName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={1.5}>
                                        <TextField
                                            id="FloorName"
                                            name="FloorName"
                                            label="Floor"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('FloorName') || ''}
                                            {...register('FloorName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={1.5}>
                                        <TextField
                                            id="RoomTypeName"
                                            name="RoomTypeName"
                                            label="Room Type"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('RoomTypeName') || ''}
                                            {...register('RoomTypeName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={1.5}>
                                        <TextField
                                            id="RoombedName"
                                            name="RoombedName"
                                            label="Bed No"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('RoombedName') || ''}
                                            {...register('RoombedName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={1.5}>
                                        <TextField
                                            id="RoomBedTypeName"
                                            name="RoomBedTypeName"
                                            label="Bed Type"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('RoomBedTypeName') || ''}
                                            {...register('RoomBedTypeName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={1.5}>
                                        <TextField
                                            id="BedRent"
                                            name="BedRent"
                                            label="Standard Rent"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            {...register('BedRent')}
                                            value={watch('BedRent') || ''}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={1.5}>
                                        {/* <Button
                                            variant="contained"
                                            size="small"
                                            sx={{
                                                backgroundColor: "#635bff",
                                                height: 35,
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                            }}
                                            onClick={handleClickCheckAvaCal}
                                        >
                                            Availability
                                        </Button> */}
                                    </Grid>
                                    <Grid item xs={6} md={1.5}>
                                        {/* <Button
                                            variant="contained"
                                            size="small"
                                            sx={{
                                                backgroundColor: "#635bff",
                                                height: 35,
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                            }}
                                            onClick={handleAllocate}
                                        >
                                            Room Allocate
                                        </Button> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <hr></hr>
                        {/* <Accordion expanded={openPaymentPlan} sx={{ m: 0,display:{xs:'none',md:'block'} }}>
                            <AccordionSummary
                                expandIcon={
                                    <IconButton onClick={() => setOpenPaymentPlan(!openPaymentPlan)}>
                                        {openPaymentPlan ? <RemoveIcon /> : <AddIcon />}
                                    </IconButton>
                                }
                                aria-controls="payment-plan-content"
                                id="payment-plan-header"
                                sx={{ minHeight: '30px' }}
                            >
                                <Typography variant="h6">Payment Plan Details</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="PlanName"
                                            name="PlanName"
                                            label="Payment Plan"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('PlanName') || ''}
                                            {...register('PlanName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            InputLabelProps={{
                                                shrink: !!watch('PlanName') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="Duration"
                                            name="Duration"
                                            label="Tenure"
                                            variant="filled"
                                            fullWidth
                                            value={watch("Duration") || ""}
                                            className="custom-textfield"
                                            {...register('Duration')}
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('Duration') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="FreeMonth"
                                            name="FreeMonth"
                                            label="FreeMonth"
                                            variant="filled"
                                            fullWidth
                                            value={watch('FreeMonth')}
                                            className="custom-textfield"
                                            {...register('FreeMonth')}
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('FreeMonth') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="LastAdjMonths"
                                            name="LastAdjMonths"
                                            label="MinAdvMonth"
                                            variant="filled"
                                            fullWidth
                                            value={watch('LastAdjMonths')}
                                            className="custom-textfield"
                                            {...register('LastAdjMonths')}
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="IncRentPerc"
                                            name="IncRentPerc"
                                            label="Increase (%)"
                                            variant="filled"
                                            fullWidth
                                            value={watch('IncRentPerc')}
                                            className="custom-textfield"
                                            {...register('IncRentPerc')}
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('IncRentPerc') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="DepositAmt"
                                            name="DepositAmt"
                                            label="Deposit"
                                            variant="filled"
                                            fullWidth
                                            value={watch('DepositAmt')}
                                            className="custom-textfield"
                                            {...register('DepositAmt')}
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('DepositAmt') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="CouponNo"
                                            name="CouponNo"
                                            label="Coupon"
                                            variant="filled"
                                            fullWidth
                                            value={watch('CouponNo') || ''}
                                            className="custom-textfield"
                                            {...register('CouponNo')}
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('CouponNo') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="DiscType"
                                            name="DiscType"
                                            label="Discount Type"
                                            variant="filled"
                                            fullWidth
                                            value={(() => {
                                                const discType = watch('DiscType');
                                                const amtDiscount = watch('AMTDISCOUNT');
                                                if (discType === "F") {
                                                    return amtDiscount === undefined ? 'FreeMonth (0)' : `FreeMonth (${amtDiscount})`;
                                                } else if (discType === "M") {
                                                    return amtDiscount === undefined ? 'Monthly (0)' : `Monthly (${amtDiscount})`;
                                                } else if (discType === "L") {
                                                    return "LumpSum";
                                                }
                                                return '';
                                            })()}
                                            className="custom-textfield"
                                            {...register('DiscType')}
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('DiscType') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={1} sm={2}>
                                        <TextField
                                            id="DiscAmt"
                                            name="DiscAmt"
                                            label="Discount"
                                            variant="filled"
                                            fullWidth
                                            value={watch('DiscAmt')}
                                            className="custom-textfield"
                                            {...register('DiscAmt')}
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={1} sm={2}>
                                        <TextField
                                            id="TotalRent"
                                            name="TotalRent"
                                            label="Total Rent"
                                            variant="filled"
                                            fullWidth
                                            value={watch('TotalRent')}
                                            {...register('TotalRent')}
                                            className="custom-textfield"
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('TotalRent') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="NetAmt"
                                            name="NetAmt"
                                            label="Net Amount"
                                            variant="filled"
                                            fullWidth
                                            value={watch('NetAmt')}
                                            className="custom-textfield"
                                            {...register('NetAmt')}
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('NetAmt') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="MonthlyAmt"
                                            name="MonthlyAmt"
                                            label="Effective Rent"
                                            variant="filled"
                                            fullWidth
                                            value={watch('MonthlyAmt')}
                                            {...register('MonthlyAmt')}
                                            className="custom-textfield"
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('MonthlyAmt') || undefined
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} sm={2}>
                                        <TextField
                                            id="AdvcRcble"
                                            name="AdvcRcble"
                                            label="Net Payable"
                                            variant="filled"
                                            fullWidth
                                            value={watch('AdvcRcble')}
                                            {...register('AdvcRcble')}
                                            className="custom-textfield"
                                            disabled={true}
                                            InputLabelProps={{
                                                shrink: !!watch('AdvcRcble') || undefined
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        <hr></hr> */}
                        <Grid item xs={12}>
                            <Accordion expanded={openKYC} sx={{ m: 0 }}>
                                <AccordionSummary
                                    expandIcon={
                                        <IconButton onClick={handleToggle}>
                                            {openKYC ? <RemoveIcon /> : <AddIcon />}
                                        </IconButton>
                                    }
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Typography variant="h6">KYC Verification</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography variant="body1" sx={{ mb: 2 }}>Identity Proof</Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2} className="form_field">
                                            <FormControl variant="filled" fullWidth className="custom-textfield">
                                                <InputLabel id="DocTypeName-select-label">
                                                    DocTypeName<span style={{ color: "red" }}>*</span>
                                                </InputLabel>
                                                <Select
                                                    labelId="DocTypeName-select-label"
                                                    id="DocTypeName-select"
                                                    name="DocTypeName"
                                                    value={selectedDocType?.Id || ""}
                                                    onChange={handleDocTypeChange}
                                                    className="custom-textfield"
                                                >
                                                    {docTypeName.map((item) => (
                                                        <MenuItem key={item.Id} value={item.Id}>
                                                            {item.Name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} md={2} className="form_field">
                                            <TextField
                                                id="DocNo"
                                                name="DocNo"
                                                label={selectedDocType.Name || "Document Number"}
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={docValue}
                                                onChange={(e) => setDocValue(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3} className="form_field">
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Expire Date"
                                                    value={docExpiryDate ? dayjs(docExpiryDate) : dayjs()}
                                                    onChange={(newDate) => setDocExpiryDate(newDate)}
                                                    renderInput={(params) => <TextField {...params} variant="filled" fullWidth className="custom-textfield" />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <Input
                                                type="file"
                                                style={{ width: '100%', display: 'flex', marginTop: '10px' }}
                                                onChange={handleFileUpload}
                                                inputProps={{ multiple: true }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2} className="form_field">
                                            <Button variant="contained" size="small" onClick={handleUpdateDoc}>
                                                Update
                                            </Button>
                                        </Grid>

                                        <Grid container spacing={2} >
                                            {documents.map((doc) => {
                                                const imageUrl = doc.ImgPath
                                                    ? doc.ImgPath.replace("http:/", "http://") // Fix protocol
                                                    : null;

                                                // Only show image if URL is valid and no error
                                                const showImage = imageUrl && !imageError &&
                                                    imageUrl !== "http://43.230.196.22:8080/" && // Filter empty paths
                                                    imageUrl.includes('.');
                                                return (
                                                    <Grid item xs={5} md={2} key={doc.MstResidentDocId} sx={{ m: 2 }}>
                                                        <Box
                                                            sx={{
                                                                position: "relative",
                                                                overflow: "hidden",
                                                                borderRadius: "12px",
                                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                                                cursor: "pointer",
                                                                background: "#fff",
                                                                "&:hover": {
                                                                    transform: "scale(1.05)",
                                                                    boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.3)",
                                                                },
                                                            }}
                                                        >
                                                            <img
                                                                src={imageUrl}
                                                                alt={doc.DocTypeName}
                                                                // onError={(e) => { e.target.src = "/fallback-image.png"; }}
                                                                onError={() => setImageError(true)}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "110px",
                                                                    objectFit: "cover",
                                                                    display: "block",
                                                                    borderTopLeftRadius: "12px",
                                                                    borderTopRightRadius: "12px",
                                                                }}
                                                            />

                                                            {/* Document Name */}
                                                            <Box
                                                                sx={{
                                                                    textAlign: "center",
                                                                    padding: "8px",
                                                                    background: "#007bff",
                                                                    color: "white",
                                                                    fontWeight: "bold",
                                                                    borderBottomLeftRadius: "12px",
                                                                    borderBottomRightRadius: "12px",
                                                                }}
                                                            >
                                                                <Typography variant="h5" sx={{ fontSize: "16px", fontWeight: "bold" }}>
                                                                    {doc.DocTypeName}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>

                        <Grid container spacing={1} sx={{ marginTop: "1px", alignItems: "center" }}>
                            <Grid item xs={12} sm={6} md={4}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item xs={6}>
                                    </Grid>
                                    <Grid item xs={6}>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6} md={8} >
                                <Grid container spacing={1}   >
                                    <Grid item xs={12} md={8} display={"flex"} alignItems={"center"} gap={"10px"}>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                    </Grid>
                                    <Grid item xs={12} md={5}>  </Grid>
                                    <Grid item xs={12} md={7} sx={{ display: 'flex', justifyContent: 'end' }}>
                                        <Tooltip title={hasUnpaidRent ? "Please pay the first installment before checking in" : (TransactionData[0]?.BookStatus === "Checked In" ? "Already Checked In" : "")}>
                                            <span>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: "#635bff",
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        marginX: 0.2
                                                    }}
                                                    onClick={handleCheckInClick}
                                                    disabled={BookId == -1 || AccGenerate || hasUnpaidRent || accountData?.BookStatus === "Checked In" || TransactionData[0].BookStatus === "CheckOut"}
                                                >
                                                    Submit
                                                </Button>
                                            </span>
                                        </Tooltip>

                                        <Tooltip >
                                            <span>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    sx={{ backgroundColor: '#635BFF', marginX: 0.2 }}
                                                    onClick={handlePrint}
                                                    disabled={BookId == -1 ? true : false}
                                                >
                                                    Print
                                                </Button>
                                            </span>
                                        </Tooltip>

                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Container>
                </Grid>
                {showPayAdvice && payAdvice.length > 0 && (
                    <Container maxWidth="lg" sx={{ mb: 1 }}>
                        <Typography variant="h6" gutterBottom sx={{ mb: 1 }}>
                            Payment Advice Details
                        </Typography>
                        <TableContainer component={Paper} sx={{ maxHeight: 300, boxShadow: '0px 2px 8px rgba(0,0,0,0.1)' }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Advice No</TableCell>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Advice Date</TableCell>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Advice For</TableCell>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Adv Amt</TableCell>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Rcd Amt</TableCell>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Balance</TableCell>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Due Days</TableCell>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Rec Date</TableCell>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Remark</TableCell>
                                        <TableCell sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#f5f5f5',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem'
                                        }}>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {payAdvice?.map((item, index) => (
                                        <TableRow key={index} sx={{
                                            height: '32px',
                                            '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                                            '&:hover': { backgroundColor: '#f0f0f0' }
                                        }}>
                                            <TableCell sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>{item?.PytAdvNo}</TableCell>
                                            <TableCell sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>{moment(item?.PytAdvDt).format("DD-MM-YYYY")}</TableCell>
                                            <TableCell sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>
                                                {item?.PytAdvFor === "D" ? "Deposit" :
                                                    item?.PytAdvFor === "R" ? "Rent" :
                                                        item?.PytAdvFor === "O" ? "Other" :
                                                            item?.PytAdvFor === "T" ? "TopUp" : ""}
                                            </TableCell>
                                            <TableCell sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>{item?.Amount}</TableCell>
                                            <TableCell sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>{item?.RcdAmt}</TableCell>
                                            <TableCell sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>{item?.BalAmount}</TableCell>
                                            <TableCell sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>{item?.DueDays}</TableCell>
                                            <TableCell sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>{item?.RecDt ? moment(item.RecDt).format("DD-MM-YYYY") : ""}</TableCell>
                                            <TableCell sx={{ padding: '4px 8px', fontSize: '0.75rem', maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item?.Remark}>
                                                {item?.Remark}
                                            </TableCell>
                                            <TableCell sx={{ padding: '4px 8px' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    {item?.PaymentSt && (
                                                        <Chip
                                                            label={item.PaymentSt}
                                                            size="small"
                                                            sx={{
                                                                fontWeight: 'bold',
                                                                color: 'white',
                                                                backgroundColor:
                                                                    item.PaymentSt.toLowerCase() === 'paid' ? '#4CAF50' :
                                                                        item.PaymentSt.toLowerCase() === 'partial' ? '#FF9800' :
                                                                            '#F44336',
                                                                fontSize: '0.7rem',
                                                                height: '24px'
                                                            }}
                                                        />
                                                    )}

                                                    {item?.PaymentSt?.toLowerCase() !== 'paid' && (
                                                        <>
                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                color="primary"
                                                                onClick={() => handleSendPaymentLink(item)}
                                                                sx={{
                                                                    padding: '2px 6px',
                                                                    minWidth: 'auto',
                                                                    fontSize: '0.65rem',
                                                                    height: '24px',
                                                                    whiteSpace: 'nowrap'
                                                                }}
                                                            >
                                                                {loadingPaymentLinks[item.PytAdvId] ? (
                                                                    <CircularProgress size={14} sx={{ color: 'white' }} />
                                                                ) : (
                                                                    'Payment Link'
                                                                )}
                                                            </Button>

                                                            <Tooltip title="Refresh Data" arrow>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => fetchPayAdvice(BookId)}
                                                                    sx={{
                                                                        backgroundColor: '#FF9800',
                                                                        color: 'white',
                                                                        padding: '2px',
                                                                        width: '24px',
                                                                        height: '24px',
                                                                        fontSize: '0.8rem',
                                                                        '&:hover': {
                                                                            backgroundColor: '#FF7043',
                                                                        },
                                                                    }}
                                                                >
                                                                    <RefreshIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    )}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                )}
                <div style={{ display: 'none' }}>
                    {<BReport contentRef={contentRef} DataObj={watch()} />}
                </div>
                <ConfirmationDialog
                    open={openCheckinConfirm}
                    onClose={() => setOpenCheckinConfirm(false)}
                    onConfirm={handleCheckinConfirm}
                    title="Confirm Check-In"
                    message="Are you sure you want to check-in For this booking?"
                />
            </Grid>
            <RoomSelection
                open={OpenHistoryTable}
                onClose={handleCloseRoom}
                propId={propId}
                dateFrom={DateFrom.format('YYYY-MM-DD')}
                dateTo={DateTo.format('YYYY-MM-DD')}
                onRoomSelect={handleRowDoubleClick}
                BedCatId={catId}
            />
            <Dialog open={openConfirmGen} onClose={() => setOpenConfirmGen(false)}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to {regenerate ? 're-generate' : 'generate'} the account?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        color='success'
                        onClick={() => {
                            handleAccountGenerateClick();
                            setOpenConfirmGen(false);
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                    <Button
                        color='error'
                        onClick={() => setOpenConfirmGen(false)}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openCancelConfirm}
                onClose={() => setOpenCancelConfirm(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Confirm Check-In Cancellation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to cancel this check-in?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCancelConfirm}
                        color="error"
                        variant="contained"
                        autoFocus
                    >
                        Yes
                    </Button>
                    <Button
                        onClick={() => setOpenCancelConfirm(false)}
                        color="primary"
                        variant="outlined"
                    >
                        No
                    </Button>

                </DialogActions>
            </Dialog>
        </Box >
    )
}

export default CheckIn;